module.exports = __webpack_public_path__ + "static/media/Gest-Vhe.2ab903c7.jpg";